import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import TypeService from '@iso/services/SettingsService/WarehouseService/TypeService';

function* deleteWarehouseType({ id }) {
    try {
        yield call(TypeService.deleteOne, id);
        yield put(actions.deleteWarehouseTypeSucceeded(id));
    } catch (error) {
        yield put(actions.deleteWarehouseTypeFailed(extractError(error)));
    }
}

function* watchDeleteWarehouseType() {
    yield takeEvery(
        types.REQUEST_DELETE_WAREHOUSE_TYPE,
        deleteWarehouseType,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteWarehouseType),
    ]);
}

export default deleteSaga;
